"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KpisSink = void 0;
const kpi_1 = require("client/components/kpi");
const kpi_header_1 = require("client/components/kpi-header");
const kpi_child_1 = require("client/components/kpi-header/kpi-child");
const kpi_stats_1 = require("client/components/kpi-header/kpi-stats");
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const recent_history_1 = require("client/components/recent-history");
const react_1 = require("react");
const React = require("react");
require("./kpis.less");
const data = [
    {
        action: "Changed cost from $150 to $188.22",
        displayName: "Diana Prince",
        date: "Oct 3, 2017 10:31 am",
        id: 1
    },
    {
        action: "Added to inventory",
        displayName: "Bruce Wayne",
        date: "Oct 1, 2017 3:15 pm",
        id: 2
    },
    {
        action: "Some action 3",
        displayName: "Someone 3",
        date: "Some date 3",
        id: 3
    },
    {
        action: "Some action 4",
        displayName: "Someone 4",
        date: "Some date 4",
        id: 3
    }
];
class KpisSink extends react_1.Component {
    render() {
        return (React.createElement("div", null,
            React.createElement("h2", null, "KPI"),
            React.createElement("div", { className: "kpi-demo" },
                React.createElement(kpi_1.KPI, { isSymbolBefore: true, label: "Most Profitable", name: "Lidocaine", performance: "1583203", symbol: "$" }),
                React.createElement(kpi_1.KPI, { label: "Highest Margin", name: "Pennsaid", performance: "95", symbol: "%" }),
                React.createElement(kpi_1.KPI, { label: "Most Popular", name: "Morlido", performance: "782392", unit: "orders" })),
            React.createElement("h2", null, "Inventory KPI Header"),
            React.createElement(kpi_header_1.KpiHeader, null,
                React.createElement(kpi_child_1.KpiChild, { subLabel: "#1234-5678-09", label: "most profitable", name: "lidocaine", performance: 1583203, theme: kpi_child_1.KpiTheme.Profit }),
                React.createElement(kpi_child_1.KpiChild, { subLabel: "#1234-5678-09", label: "highest margin", name: "Pennsaid", performance: 28, theme: kpi_child_1.KpiTheme.Margin }),
                React.createElement(kpi_child_1.KpiChild, { subLabel: "#1234-5678-09", label: "Most approved", name: "Morlido", performance: 72846, theme: kpi_child_1.KpiTheme.Approved })),
            React.createElement("h2", null, "User KPI Header"),
            React.createElement(kpi_header_1.KpiHeader, null,
                React.createElement(kpi_child_1.KpiChild, { subLabel: "Jamm Orthodonitia", label: "most profits processed", name: "leslie knope", performance: 1921670, theme: kpi_child_1.KpiTheme.Profit }),
                React.createElement(kpi_child_1.KpiChild, { subLabel: "Gotham Neurological Center", label: "Most orders dispensed", name: "Barry Flash", performance: 7281, theme: kpi_child_1.KpiTheme.Normal }),
                React.createElement(kpi_stats_1.KpiStats, { color: "gradient", stats: { admin: 182, manager: 534, frontDesk: 697 } })),
            React.createElement("h2", null, "KPI Element"),
            React.createElement(kpi_header_1.KpiHeader, { center: false },
                React.createElement(kpi_stats_1.KpiStats, { stats: {
                        "priority": "high",
                        "Avg Qty": 15,
                        "Refills": 3192,
                        "orders": 17291,
                        "revenue": 637192.1,
                        "Profit": 172028.25
                    } })),
            React.createElement("h2", null, "KPI Element"),
            React.createElement(kpi_header_1.KpiHeader, { center: false },
                React.createElement(kpi_title_1.KpiTitle, { label: "Lidocaine", subLabel: "71085-0011-50" }),
                React.createElement(kpi_stats_1.KpiStats, { stats: {
                        "priority": "high",
                        "Avg Qty": 15,
                        "Refills": 3192,
                        "orders": 17291,
                        "revenue": 637192.1,
                        "Profit": 172028.25
                    } })),
            React.createElement("h2", null, "Recent History"),
            React.createElement(recent_history_1.RecentHistory, { data: data })));
    }
}
exports.KpisSink = KpisSink;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/kitchen-sink/kpis/kpis.tsx
// module id = 3638
// module chunks = 0